var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('h1',[_vm._v(_vm._s(_vm.signerAddr))]),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.connected),expression:"!connected"}],attrs:{"type":"primary"},on:{"click":_vm.connectWallet}},[_vm._v("Connect Wallet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }